import { render, staticRenderFns } from "./tabCmsContent.vue?vue&type=template&id=525199d6&"
import script from "./tabCmsContent.vue?vue&type=script&lang=ts&"
export * from "./tabCmsContent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports